import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

interface RequirementListProps {
  requirements: string[];
  className?: string;
}

const RequirementList: React.FC<RequirementListProps> = ({ requirements, className = '' }) => {
  if (!requirements.length) return null;

  return (
    <ul className={`mt-2 ml-4 ${className}`}>
      {requirements.map((requirement, index) => (
        <li key={index}>
          <Text type="secondary">{requirement}</Text>
        </li>
      ))}
    </ul>
  );
};

export default RequirementList;
